import type { Participant } from '../../../schema/sport/entry.js';

export type NameSize = 'short' | 'medium' | 'full';

function getTeamName(participant: Participant, nameSize: NameSize): string {
  let name;
  switch (nameSize) {
    case 'short':
      name = participant.shortName;
      break;
    case 'full':
      name = participant.name;
      break;
    default:
      name = participant.mediumName;
      break;
  }
  return name || participant.mediumName || participant.shortName || participant.name;
}

/**
 * Function to determine the name and title of a team.
 *
 * @param participant The participant object containing different name sizes
 * @param nameSize Different name sizes
 * @returns Gets and return the name and title for a team
 */
export function getTeamNameAndTitle(participant: Participant, nameSize: NameSize): [string, string] {
  const name = getTeamName(participant, nameSize);
  const title = participant.name || name;
  return [name, title];
}
